import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 20h16","key":"svg-0"}],["path",{"d":"M9.4 10h.6m4 0h.6","key":"svg-1"}],["path",{"d":"M7.8 15h7.2","key":"svg-2"}],["path",{"d":"M6 20l3.5 -10.5","key":"svg-3"}],["path",{"d":"M10.5 6.5l.5 -1.5h2l2 6m2 6l1 3","key":"svg-4"}],["path",{"d":"M3 3l18 18","key":"svg-5"}]]

const IconTrafficConeOff = createReactComponent('outline', 'traffic-cone-off', 'TrafficConeOff', __iconNode);

export default IconTrafficConeOff;